import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { ItrConfigErrorProps } from './types';
import { SaveItrConfigError } from '@bechtel/types';

const getErrorMessage = (error: ItrConfigErrorProps['error']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case SaveItrConfigError.PROJECT_MILESTONE_TYPE_NOT_FOUND:
      return <Trans>Project Milestone Type not found.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

const ItrConfigError: FC<ItrConfigErrorProps> = ({ error, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Inspection Test Record Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(error)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
export default ItrConfigError;
